import { motion, Variants } from "motion/react";
import { FC } from "react";
import styled from "styled-components";

import { StyledPageWrapper } from "./controls.panels.styled";

const StyledDraggableDiv = styled.div`
  width: 200px;
  height: 70px;
  background-color: #c4e95d;
  margin-inline-start: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledDraggableDiv2 = styled(motion.div)`
  width: 200px;
  height: 70px;
  background-color: #5d72e9;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  z-index: 20000000;
`;

const animeVariants: Variants = {
  initialVar: {
    scale: 1,
    x: 50,
  },
  second: {
    scale: 1.7,
    x: 100,
    y: 200,
    transition: {
      delay: 1,
      duration: 3,
      repeat: Infinity,
      repeatDelay: 2,
      ease: "easeInOut",
    },
  },
};

export const FramerTestPanel: FC = () => {
  return (
    <StyledPageWrapper>
      <h1>Sample framer</h1>
      <StyledDraggableDiv
        as={motion.div}
        initial={{ scale: 1 }}
        animate={{ scale: 1.5 }}
        exit={{ scale: 1 }}
        whileHover={{
          scale: 0.5,
          transition: {
            duration: 2,
          },
        }}
        transition={{
          delay: 1,
          duration: 3,
          repeat: Infinity,
          repeatDelay: 2,
          ease: "easeInOut",
        }}
      >
        Div Contents
      </StyledDraggableDiv>

      <StyledDraggableDiv2
        as={motion.div}
        variants={animeVariants}
        initial="initialVar"
        animate="second"
        drag
      >
        Second
      </StyledDraggableDiv2>
    </StyledPageWrapper>
  );
};
